import React from "react";
import { ModelElementType } from "@/components/entities";
import { ModelRow } from "./ModelRow";
import { formatCompactRelativeTime } from "./selectors";

interface ModelRowsProps {
  models: ModelElementType[];
  /** The row just created plays the settle-in outline. */
  freshModelId?: string | null;
  showActiveCount?: boolean;
  movable?: boolean;
}

/** A list of model rows sharing one recency label and the fresh-row outline. */
export const ModelRows: React.FC<ModelRowsProps> = ({
  models,
  freshModelId,
  ...rowProps
}) => (
  <>
    {models.map((model) => (
      <ModelRow
        key={model.model_id}
        model={model}
        isFresh={model.model_id === freshModelId}
        meta={
          model.last_opened_by_me != null
            ? formatCompactRelativeTime(model.last_opened_by_me)
            : undefined
        }
        {...rowProps}
      />
    ))}
  </>
);
